// Single backward-compatibility boundary for classification options.
//
// `QueryRequest.options` is canonically CodeOption[] ({ label, description }),
// but legacy/stored rows may hold a plain string[] (labels only), and external
// producers may pass either. Call normalizeOptions() whenever options come from
// the DB or a request body so every downstream consumer sees CodeOption[].

import { CodeOption } from '@/types/pulse';

export function normalizeOptions(raw: unknown): CodeOption[] {
  if (!Array.isArray(raw)) return [];
  const out: CodeOption[] = [];
  for (const item of raw) {
    if (typeof item === 'string') {
      // Legacy shape: a bare label, no description.
      const label = item.trim();
      if (label) out.push({ label, description: null });
    } else if (item && typeof item === 'object' && 'label' in item) {
      const label = String((item as { label: unknown }).label ?? '').trim();
      if (!label) continue;
      const d = (item as { description?: unknown }).description;
      out.push({
        label,
        description: typeof d === 'string' && d.trim() ? d.trim() : null
      });
    }
  }
  return out;
}
